import { ActionIcon, Button } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { InfoIcon } from "../../../shared/svg";
import useProfileStore from "../../../store/useProfileStore";
import { useTranslation } from "react-i18next";

interface TourProps {
  onClick: () => void;
}

export const TourButton = ({ onClick }: TourProps) => {
  const mobile = useMediaQuery("(max-width: 650px)");
  const { profileLanguage } = useProfileStore();
  const { t } = useTranslation();

  const languageKey = profileLanguage ? Object.keys(profileLanguage)[0] : "en";

  return mobile ? (
    <ActionIcon
      variant="filled"
      color="rgba(190, 75, 219, 0.7) "
      radius="xl"
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1,
        width: 36,
        height: 36,
      }}
      onClick={onClick}
    >
      <InfoIcon />
    </ActionIcon>
  ) : (
    <Button
      onClick={onClick}
      variant="light"
      style={{
        position: "fixed",
        bottom: 32,
        left: languageKey === "uk" ? 8 : 32,
        zIndex: 1,
      }}
    >
      {t("start_tour")}
    </Button>
  );
};
